module.exports = __webpack_public_path__ + "static/img/i_record.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i_record.png
// module id = 71xM
// module chunks = 43 109